import React, { ButtonHTMLAttributes } from 'react';

import { Container } from './styles';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  $width?: string;
  $height?: string;
  $marginRight?: string;
  $marginTop?: string;
  $marginBottom?: string;
  $marginLeft?: string;
  $shadow?: boolean;
  $fontWeigth?: string;
  $fontSize?: string;
}

const Button: React.FC<ButtonProps> = ({
  children,
  $width,
  $height,
  $marginRight,
  $marginTop,
  $marginLeft,
  $marginBottom,
  $fontWeigth,
  $fontSize,
  ...rest
}) => (
  <Container
    type="button"
    $width={$width}
    $height={$height}
    $marginRight={$marginRight}
    $marginTop={$marginTop}
    $marginLeft={$marginLeft}
    $marginBottom={$marginBottom}
    $fontWeigth={$fontWeigth}
    $fontSize={$fontSize}
    {...rest}
  >
    {children}
  </Container>
);

export default Button;
